import { render } from "./Delta.vue?vue&type=template&id=746f801e&scoped=true"
import script from "./Delta.vue?vue&type=script&lang=js"
export * from "./Delta.vue?vue&type=script&lang=js"

import "./Delta.vue?vue&type=style&index=0&id=746f801e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746f801e"]])

export default __exports__